import { LeavePageActionResult } from '@app/core/leave-page-handler/models/leave-page-action-result';
import { Action } from '@ngrx/store';

export enum LeavePageInternalActionTypes {
  PreventLeavePage = '[LeavePage] Prevent Leave Page',
  PreventLeavePageFail = '[LeavePage] Prevent Leave Page Fail',

  PreventLeaveEditing = '[LeavePage] Prevent Leave Editing',
  PreventLeaveEditingFail = '[LeavePage] Prevent Leave Editing Fail',

  LeavePageCanceled = '[LeavePage] Leave Page Canceled',

  UpdateLeavePageActionResult = '[LeavePage] Update Leave Page Action Result',

  SetNextPageUrl = '[LeavePage] Set Next Page Url',
  GoToNextPageUrlOnConfirm = '[LeavePage] Go To Next Page URL On Confirm'
}

class PreventLeavePage implements Action {
  readonly type = LeavePageInternalActionTypes.PreventLeavePage;

  constructor(public payload: { confirmActions?: Action[] }) {
  }
}

export class PreventLeavePageFail implements Action {
  readonly type = LeavePageInternalActionTypes.PreventLeavePageFail;

  constructor(public payload: Error) {
  }
}

class PreventLeaveEditing implements Action {
  readonly type = LeavePageInternalActionTypes.PreventLeaveEditing;

  constructor(public payload: { confirmActions?: Action[] }) {
  }
}

export class PreventLeaveEditingFail implements Action {
  readonly type = LeavePageInternalActionTypes.PreventLeaveEditingFail;

  constructor(public payload: Error) {
  }
}

export class LeavePageCanceled implements Action {
  readonly type = LeavePageInternalActionTypes.LeavePageCanceled;
}

export class UpdateLeavePageActionResult implements Action {
  readonly type = LeavePageInternalActionTypes.UpdateLeavePageActionResult;

  constructor(public payload: { action?: LeavePageActionResult }) {
  }
}

export class SetNextPageUrl implements Action {
  readonly type = LeavePageInternalActionTypes.SetNextPageUrl;
  constructor(public payload: {nextPageUrl: string}) {}
}

export class GoToNextPageUrlOnConfirm implements Action {
  readonly type = LeavePageInternalActionTypes.GoToNextPageUrlOnConfirm;
}

export type LeavePageInternalActions =
  | PreventLeavePage
  | PreventLeavePageFail
  | PreventLeaveEditing
  | PreventLeaveEditingFail
  | LeavePageCanceled
  | UpdateLeavePageActionResult
  | SetNextPageUrl
  | GoToNextPageUrlOnConfirm;

export function preventLeavePage() {
  return new PreventLeavePage({confirmActions: []});
}

export function preventLeaveEditing(confirmActions?: Action[]) {
  return new PreventLeaveEditing({confirmActions});
}

export function setNextPageUrl(nextPageUrl: string) {
  return new SetNextPageUrl({nextPageUrl});
}

export function setLeavePageActionResult(action: LeavePageActionResult) {
  return new UpdateLeavePageActionResult({action});
}

export function resetLeavePageActionResult() {
  return new UpdateLeavePageActionResult({action: null});
}
